import { render } from "./ResultadosEncuesta.vue?vue&type=template&id=1f78d2b0"
import script from "./ResultadosEncuesta.vue?vue&type=script&lang=js"
export * from "./ResultadosEncuesta.vue?vue&type=script&lang=js"

import "./ResultadosEncuesta.vue?vue&type=style&index=0&id=1f78d2b0&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.5.28_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__